<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
  <!-- START navbar header-->
  <div class="navbar-header">
    <a class="navbar-brand" [routerLink]="['/public/shop']">
      <div class="brand-logo">
        <img
          class="img-fluid"
          src="assets/img/HXA_io_Portal_85x34px_tr_.png"
          alt="App Logo"
        />
      </div>
      <div class="brand-logo-collapsed">
        <img class="img-fluid" src="assets/img/logo-single.png" alt="App Logo" />
      </div>
    </a>
  </div>
  <!-- END navbar header-->
  <!-- START Right Navbar-->
  <ul class="navbar-nav flex-row ml-auto">
    <li class="nav-item py-2 mr-4">
      <select
        class="form-control"
        [ngModel]="selectedLanguage"
        (ngModelChange)="setLang($event)"
      >
        <option [value]="lang.code" *ngFor="let lang of getLangs()">
          {{ lang.text | translate }}
        </option>
      </select>
    </li>
    <!-- Cart icon with badge -->
    <li class="nav-item d-none d-md-block">
      <a class="nav-link position-relative" (click)="goToCart()" style="cursor: pointer">
        <em class="fa fa-shopping-cart"></em>
        <span *ngIf="cartItemCount > 0" class="badge badge-danger cart-badge">{{
          cartItemCount
        }}</span>
      </a>
    </li>
    <!-- Login button -->
    <li class="nav-item">
      <a
        class="nav-link btn btn-outline-primary btn-sm ml-2"
        (click)="login()"
        style="cursor: pointer"
      >
        LOGIN
      </a>
    </li>
  </ul>
  <!-- END Right Navbar-->
</nav>
<!-- END Top Navbar-->
